import React, { Component, PropTypes } from 'react';
import CodeMirrorItem from './CodeMirrorItem';
import ReactTabs from 'react-tabs';
import Frame2 from './Frame2';
import translate from '../../i18n/translate';
var licenseStr = '<script src="js/spread/license.js" type="text/javascript"></script>\r\n';

var Tab = ReactTabs.Tab;
var Tabs = ReactTabs.Tabs;
var TabList = ReactTabs.TabList;
var TabPanel = ReactTabs.TabPanel;

class TutorialItem extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const options = {
            lineNumbers: true,
            mode: 'htmlmixed',
            foldGutter: true,
            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
        };

        const { htmlContent, strings } = this.props;

        return (
            <Tabs>
            <TabList>
                <Tab>{strings.Example}</Tab>
                <Tab>{strings.SourceCode}</Tab>
            </TabList>
            <TabPanel>
                <Frame2 htmlContent={htmlContent} />
            </TabPanel>
            <TabPanel>
                <CodeMirrorItem htmlContent={htmlContent.replace(licenseStr, '')} options={options} />
            </TabPanel>
        </Tabs>

        );
    }
}

TutorialItem.defaultProps = {
    strings: {}
};

export default translate('SourceTab')(TutorialItem)



// WEBPACK FOOTER //
// ./client/components/TutorialItem.js